// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"91e981d9","605":"dc7d0500"}[chunkId] + ".chunk.css";
};